import { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import PropertySlider from './PropertySlider';
import './DestinationSection.css';

gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function DestinationSection({ ready = true }) {
  const scope = useRef(null);
  useGSAP(() => {
    if (!ready) return;
    const media = gsap.matchMedia();
    media.add('(prefers-reduced-motion: no-preference)', () => {
      const defaults = { duration: 0.8, ease: 'power3.out', clearProps: 'transform,opacity,visibility' };
      gsap.timeline({ defaults, scrollTrigger: { trigger: '.destination-intro', start: 'top 88%', once: true } })
        .from('.destination-intro .destination-eyebrow', { autoAlpha: 0, y: 15 })
        .from('.destination-intro h2', { autoAlpha: 0, y: 35 }, 0.1)
        .from('.destination-intro__copy', { autoAlpha: 0, y: 20 }, 0.2);
      gsap.timeline({ defaults, scrollTrigger: { trigger: '.destination-heading', start: 'top 88%', once: true } })
        .from('.destination-heading > *', { autoAlpha: 0, y: 25, stagger: 0.1 });
      gsap.from('.property-card-shell', { ...defaults, autoAlpha: 0, y: 50, scale: 0.97, stagger: 0.15,
        scrollTrigger: { trigger: '.property-slider', start: 'top 88%', once: true } });
    });
    return () => media.revert();
  }, { scope, dependencies: [ready], revertOnUpdate: true });

  return (
    <section ref={scope} className="destination-section" aria-label="Discover JamRock Escape">
      <div className="destination-intro" id="jamrock-feeling">
        <div>
          <p className="destination-eyebrow">The JamRock feeling</p>
          <h2>A place to pause.<br />A stay to remember.</h2>
        </div>
        <div className="destination-intro__copy">
          <p>Some journeys are for adventure. Others bring you closer to work, family, or a fresh start. JamRock Escape is a welcoming base for whatever brings you here.</p>
          <p className="destination-intro__welcome">Make yourself at home.</p>
        </div>
      </div>
      <div className="destination-heading" id="our-stays">
        <p className="destination-eyebrow">Find your place</p>
        <h2>Different destinations. The same good feeling.</h2>
        <p>Explore the stays and find the setting that suits your journey.</p>
      </div>
      <PropertySlider />
    </section>
  );
}
